export function genQueryParam (field, reslationship, val1, val2) {
  // 生成查询参数
  let p = field + '%7C' + reslationship + '%7C' + val1
  if (val2 !== null && val2 !== undefined) {
    p = p + '%7C' + val2
  }
  return p
}

export function genSortParam (field, asc) {

  return field + '%7C' + asc
}
